/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Draftsnone1Inputs */



/**

* @param {_Wiki_Draftsnone1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_draftsnone1 = /** @type {((inputs?: _Wiki_Draftsnone1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Draftsnone1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Keine Entwürfe vorhanden")
});
export { _wiki_draftsnone1 as "_wiki_draftsNone" }